// extracted by mini-css-extract-plugin
module.exports = {"input":"inputs_input__3DFB2","item":"inputs_item__OJGA8","searchinput":"inputs_searchinput__3tkzO"};